module.exports = __webpack_public_path__ + "static/media/3.eb4fbf22.jpg";